import {useRoute} from 'vue-router'

export function getRoute() {
    const route = useRoute()
    return {
        route,
    }
}

